<img
	class="session-attachments-icon"
	[src]="paperclipIcon"
	alt=""
	aria-hidden="true"
/>
@if (showBadge && attachmentsCount > 0) {
  <span
    class="badge"
    >
    {{attachmentsCount}}
  </span>
}
<ng-content></ng-content>
